import React, { useEffect, useState } from 'react';
import {ButtonBase} from '../elements';
import {StepForm} from "../../models/api/codegen/code";
import {addFormatDate} from "../../utils/FormatDate";
import {StepFooter, View} from "./step-parts-components/StepFooter";
import {HorizontalLine} from "./step-parts-components/HorizontalLine";
import {MoreLessToggle} from "../custom/MoreLessToggleInner";
import styled from "styled-components";
import {SportIconAndTitle} from "./step-parts-components/SportIconAndTitle";
import {useTranslation} from "react-i18next";
import {Info} from "./Steps";
import {Visible} from "../../utils/Visible";
import {BetStatusButton} from "../MyBets/BetStatusButton";


const ShowSubStepsButton = styled(ButtonBase)`
    color: #EACD40;
    font-weight: 500;
    background-color: #16181B;
    border: 1px solid #EACD40;
    border-radius: 8px;
` as typeof ButtonBase;


interface StepProps {
    step: StepForm
    view: View
}

export function ExpressOrSystemStep(props: StepProps) {

    const {step, view} = props;
    const [showSubSteps, setShowSubSteps] = useState<boolean>(false);
    const {t} = useTranslation();


    useEffect(() => {
        // подсчет общего коэффициента купона,
        // что является суммой коэффициентов всех включенных купонов в текущем купоне
        if (step.odds == undefined) {
            step.odds = step.steps
                ?.map(s => (s.odds == undefined ? 0 : s.odds))
                .reduce((acc, curr) => acc + curr, 0);
        }
    }, [step]);

    function marketTypeAndSelection(market?: string, selection?: string) {
        return market + ' - ' + selection;
    }

    function handleClick() {
        setShowSubSteps(prevState => !prevState);
    }

    return (
        <div className="rounded-[8px] mb-[10px] bg-[#272d33] text-[16px]">
            <h5>
                <div className="py-[8px] px-[10px]">
                    <div className="flex justify-between items-center">
                        <div>
                            <ShowSubStepsButton onClick={handleClick}>
                                <div className="flex items-center py-[4px] pr-[5px] pl-[17px]">
                                    {t(`coupons.${step.type}.tabTitle`)}
                                    {' '}{step.steps && step.steps.length}
                                    <MoreLessToggle isOpen={showSubSteps}/>
                                </div>
                            </ShowSubStepsButton>
                        </div>
                        <div>
                            <div className="text-right" style={{textAlign: 'right'}}>№{step.id}</div>
                            <div className="text-[#ABABAB]">{addFormatDate(step.date)}</div>
                        </div>
                    </div>
                </div>

                {showSubSteps && step.steps && step.steps.map((subStep, index) => (
                    <React.Fragment key={subStep.id + '_' + index}>
                        {/*first line blue other black*/}
                        <HorizontalLine borderColor={(index === 0) ? '#03A9F4' : 'black'}/>

                        <div className="py-[8px] px-[10px]">
                            {subStep.fixture && <SportIconAndTitle
                                imageUrl={subStep.fixture.siu}
                                color={subStep.fixture.sc}
                                showLiveBadge={subStep.fixture.s === 'LIVE'}
                                sportName={subStep.fixture.sn}/>}
                            <div className="text-[16px]">
                                {marketTypeAndSelection(subStep.market, subStep.selection)}
                            </div>
                            {<Info step={subStep} view={view}/>}
                            <Visible value={view === 'my-bets'}>
                                <div className="flex justify-between mt-[5px] text-[#ABABAB]">
                                    <span>{t('steps.step.coefficient')}</span>
                                    {subStep.odds && <span>{subStep.odds.toFixed(2)}</span>}
                                </div>
                                <div className="flex justify-between items-center">
                                    <BetStatusButton
                                        calculated={subStep.calculated}
                                        betStatus={subStep.status}
                                        winning={subStep.winning}
                                        type={subStep.type}
                                        isChild={true}
                                        parentStatus={step.status}
                                        steps={null}
                                    />
                                </div>
                            </Visible>
                        </div>

                    </React.Fragment>
                ))}
            </h5>

            {step.steps && <StepFooter odds={step.odds} step={step} view={view}/>}

        </div>
    );
}
